// @flow
'use strict';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import CampoIntervaloData from '../../../common/campos_busca_estruturada/campo_intervalo_data';
import { InputForm } from '../../../common/input';

export const CLASSIFICACOES = [
  { value: '-1', label: 'Não Informada' },
  { value: '00', label: 'Revenda' },
  { value: '01', label: 'Matéria-prima' },
  { value: '03', label: 'Em processo' },
  { value: '04', label: 'Produto acabado' },
  { value: '05', label: 'Subproduto' },
  { value: '06', label: 'Intermediário' },
  { value: '07', label: 'Uso e consumo' },
  { value: '08', label: 'Ativo imobilizado' },
  { value: '09', label: 'Serviços' },
  { value: '10', label: 'Outros insumos' },
  { value: '99', label: 'Outras' },
];

export default function CamposClassificacaoFiscal() {
  return (
      <>
        <fieldset>
          <legend>Destinação</legend>
        </fieldset>

        <Row>
          <Col sm={ 6 }>
            <InputForm sm={ 9 } name="classificacao_fiscal_geral" label="Classificação Geral" options={ CLASSIFICACOES }/>
          </Col>
          <Col sm={ 6 }>
            <CampoIntervaloData rotulo="Data da Classificação" nome="classificacao_realizada_em" tamanhoLabel={ 4 }/>
          </Col>
        </Row>
      </>
  );
}